import { useTable, useSortBy, useFilters } from "react-table";
import ServerSideGlobalFilter from "../../../layouts/DataTables/ServerSideDataTable/ServerSideGlobalFilter";

const getStableRowKey = (row) => row.original?.scrId || row.original?.scrNo || row.id;

const SCRV2ReportListTable = ({
  searchChanged,
  pageNo,
  pageSizeChange,
  myPageSize,
  totalRecords,
  goToPreviousPage,
  goToNextPage,
  columns,
  data,
}) => {
  const resolvedPageSize = Number(myPageSize) > 0 ? Number(myPageSize) : 5;
  const totalPages =
    totalRecords == null || totalRecords === 0
      ? 1
      : Math.ceil(totalRecords / resolvedPageSize);
  const canGoPrevious = pageNo > 0;
  const canGoNext = (pageNo + 1) * resolvedPageSize < totalRecords;

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: resolvedPageSize },
    },
    useFilters,
    useSortBy,
  );

  const checkLastPage = () => {
    if (Math.floor(totalRecords % resolvedPageSize) === 0) {
      if (pageNo + 1 < Math.floor(totalRecords / resolvedPageSize)) {
        goToNextPage(pageNo + 1, resolvedPageSize);
      }
    } else if (pageNo < Math.floor(totalRecords / resolvedPageSize)) {
      goToNextPage(pageNo + 1, resolvedPageSize);
    }
  };

  return (
    <div style={{ overflow: "hidden", overflowX: "scroll", minHeight: "350px" }}>
      <ServerSideGlobalFilter
        totalRecords={totalRecords}
        preGlobalFilteredRows={preGlobalFilteredRows}
        globalFilter={state.globalFilter}
        setGlobalFilter={setGlobalFilter}
        searchChanged={searchChanged}
      />
      <table
        className="table striped bordered hover scr-v2-detail-report-table"
        {...getTableProps()}
        style={{ minHeight: "330pxs" }}
      >
        <thead>
          {headerGroups.map((headerGroup) => {
            const { key: headerGroupKey, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
            return (
              <tr key={headerGroupKey} {...headerGroupProps}>
                {headerGroup.headers.map((column) => {
                  const { key: columnKey, ...columnProps } = column.getHeaderProps(
                    column.getSortByToggleProps(),
                  );
                  return (
                    <th
                      key={columnKey}
                      {...columnProps}
                      style={{ verticalAlign: "top", whiteSpace: "nowrap" }}
                    >
                      {column.render("Header")}
                      <span>{column.isSorted ? (column.isSortedDesc ? " ▼" : " ▲") : ""}</span>
                    </th>
                  );
                })}
              </tr>
            );
          })}
        </thead>
        <tbody {...getTableBodyProps()} style={{ Height: "auto" }}>
          {rows && rows.length > 0 ? (
            rows.map((row) => {
              prepareRow(row);
              const rowKey = getStableRowKey(row);
              const { key: _, ...rowProps } = row.getRowProps();

              return (
                <tr
                  {...rowProps}
                  className="table-hover-class"
                  key={rowKey}
                  style={{ cursor: "pointer" }}
                >
                  {row.cells.map((cell) => {
                    const { key: cellKey, ...cellProps } = cell.getCellProps();
                    return (
                      <td key={cellKey} {...cellProps} style={{ verticalAlign: "top" }}>
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={headerGroups[0].headers.length} style={{ textAlign: "center" }}>
                No record found
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <ul className="pagination float-right pagination-scroll">
        <select
          className="form-control"
          value={resolvedPageSize}
          onChange={(e) => pageSizeChange(Number(e.target.value))}
          style={{ width: "120px", height: "38px" }}
        >
          {[5, 10, 20, 30, 40, 50, 100].map((optionSize) => (
            <option key={optionSize} value={optionSize}>
              Show {optionSize}
            </option>
          ))}
        </select>
        <li
          className="page-item pointer"
          onClick={pageNo === 0 ? null : () => goToPreviousPage(0, resolvedPageSize)}
          disabled={!canGoPrevious}
        >
          <a className="page-link">&laquo;</a>
        </li>
        <li
          className="page-item pointer"
          onClick={pageNo === 0 ? null : () => goToPreviousPage(pageNo - 1, resolvedPageSize)}
          disabled={!canGoPrevious}
        >
          <a className="page-link">&lt;</a>
        </li>
        <li className="page-item pointer" onClick={checkLastPage} disabled={!canGoNext}>
          <a className="page-link">&gt;</a>
        </li>
        <li
          className="page-item pointer"
          onClick={
            pageNo > Math.floor(totalRecords / resolvedPageSize) - 1
              ? null
              : () => {
                  goToNextPage(
                    Math.floor(totalRecords % resolvedPageSize) === 0
                      ? Math.floor(totalRecords / resolvedPageSize) - 1
                      : Math.floor(totalRecords / resolvedPageSize),
                    resolvedPageSize,
                  );
                }
          }
          disabled={!canGoNext}
        >
          <a className="page-link">&raquo;</a>
        </li>
        <li>
          <a className="page-link" style={{ width: "auto" }}>
            Page
            <strong>
              {" "}
              {pageNo + 1} of {totalPages}
            </strong>
          </a>
        </li>
        <li>
          <a className="page-link">
            <input
              className="form-control"
              type="number"
              min={1}
              max={totalPages}
              defaultValue={pageNo + 1}
              onChange={(e) => {
                const nextPage = e.target.value ? Number(e.target.value) - 1 : 0;
                if (nextPage < 0) {
                  return;
                }
                goToNextPage(nextPage, resolvedPageSize);
              }}
              onInput={(e) => {
                const val = parseInt(e.target.value, 10);

                if (val < 1) {
                  e.target.value = 1;
                }

                if (val > totalPages) {
                  e.target.value = totalPages;
                }
              }}
              style={{ width: "100px", height: "20px" }}
            />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SCRV2ReportListTable;
